import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import './ReservationDetailsActions.css';
import { setShowCalendar } from 'bookingform';
import cancelarIcon from '../../../static/images/cancelar_icon.png';
import cambiarFechasIcon from '../../../static/images/cambiar_fechas_icon.png';
import cambiarHabitacionIcon from '../../../static/images/cambiar_habitacion_icon.png';
import solicitarFacturaIcon from '../../../static/images/solicitar_factura_icon.png';
import {
  setIsEditingBooking,
} from '../../../actions/Booking';
import { setOpenReservationDetails } from '../../../actions/Session';
import ShareDownload from '../../share/ShareDownload';
import BookingDetailHotel from '../../ds/organism/Hotel/hotelContact';

// eslint-disable-next-line no-unused-vars
const ReservationDetailsActions = (props, context) => {
  const navigate = useNavigate();
  const onCancelBookingClick = () => {
    navigate('/cancellation/');
  };
  const onChangeRoomsClick = () => {
    props.dispatch(setIsEditingBooking(true));
    props.dispatch(setOpenReservationDetails(false));
    navigate('/rooms/');
  };
  const onChangeDatesClick = () => {
    props.dispatch(setIsEditingBooking(true));
    props.dispatch(setOpenReservationDetails(false));
    window.scrollTo(0, 0);
    props.dispatch(setShowCalendar(true));
  };
  const renderCallCenterPhones = () => {
    switch (props.clientIpCountryCode) {
      case 'MX':
        return (<p className="reservation_details_actions_contact_info">
                {context.t('Mexico and Others:')} <a href={'tel:+52 (55) 85266116'}>+52 (55) 85266116</a>
            </p>);
      case 'ES':
        return (<p className="reservation_details_actions_contact_info">
                {context.t('Spain and Europe:')} <a href={'tel:+34 (960) 479446'}>+34 (960) 479446</a>
            </p>);
      case 'US':
        return (<p className="reservation_details_actions_contact_info">
                {context.t('USA:')} <a href={'tel:+1 (863) 2234530'}>+1 (863) 2234530</a>
            </p>);
      case 'CA':
        return (<p className="reservation_details_actions_contact_info">
                {context.t('Canada:')} <a href={'tel:+1 (647) 6916811'}>+1 (647) 6916811</a>
            </p>);
      case 'AR':
        return (<p className="reservation_details_actions_contact_info">
                {context.t('Argentina:')} <a href={'tel:0 (800) 8001464'}>0 (800) 8001464</a>
            </p>);
      case 'BR':
        return (<p className="reservation_details_actions_contact_info">
                {context.t('Brazil:')} <a href={'tel:(11) 32302292'}>(11) 32302292</a>
            </p>);
      case 'UK':
        return (<p className="reservation_details_actions_contact_info">
                {context.t('UK:')} <a href={'tel:+44 (203) 8074491'}>+44 (203) 8074491</a>
            </p>);
      default:
        return (
        <Fragment>
          <p className="reservation_details_actions_contact_info">
            {context.t('Mexico and Others:')} <a href={'tel:+52 (55) 85266116'}>+52 (55) 85266116</a>
          </p>
          <p className="reservation_details_actions_contact_info">
            {context.t('Spain and Europe:')} <a href={'tel:+34 (960) 479446'}>+34 (960) 479446</a>
          </p>
        </Fragment>);
    }
  };

  return (
        <div className="reservation_details_actions_container">
          <h2 className="reservation_details_actions_title">{context.t('Is everything correct?')}</h2>
          <p className="reservation_details_actions_subtitle">
            {context.t('You can check or modify your booking online without needing to register.')}
          </p>

          <div className="reservation_details_actions_options">
            {(props.bookingStatus === 'CONF' || props.bookingStatus === 'PEND' || props.isEditingBooking === true)
              && <a onClick={() => onCancelBookingClick()}
              className="reservation_details_actions_link">
              <img src={cancelarIcon} alt="Cancelar" className="reservation_details_actions_icon" />
              {context.t('Cancel your booking')}
            </a>}
            {(props.bookingStatus === 'CONF' || props.isEditingBooking === true)
            && props.cart.cartHotel.rooms.length > 0
            && props.cart.cartHotel.rooms[0].rate.name === 'FLEXIBLE'
            && <a onClick={() => onChangeDatesClick()} className="reservation_details_actions_link">
              <img src={cambiarFechasIcon} alt="Cambiar fechas" className="reservation_details_actions_icon" />
              {context.t('Change the dates')}
            </a>}
            {(props.bookingStatus === 'CONF' || props.isEditingBooking === true)
            && props.cart.cartHotel.rooms.length > 0
            && props.cart.cartHotel.rooms[0].rate.name === 'FLEXIBLE'
            && <a onClick={() => onChangeRoomsClick()} className="reservation_details_actions_link">
              <img src={cambiarHabitacionIcon} alt="Cambiar habitación" className="reservation_details_actions_icon" />
              {context.t('Change your room')}
            </a>
            }
            <a onClick={(e) => e.preventDefault()} className="reservation_details_actions_link"
              style={{
                color: '#004499',
                fontFamily: 'Roboto, sans-serif',
                fontWeight: 200,
                fontSize: '0.95rem',
              }}>
              <img src={solicitarFacturaIcon} alt="Descargar voucher" className="reservation_details_actions_icon" />
              <ShareDownload
                locator={props.locator}
                lang={props.lang}
                is_agent_voucher={false}
                className="font-normal"
              />
            </a>
            {(props.editBooking != null && props.editBooking.agent_code != null && props.editBooking.agent_code !== ''
            && props.editBooking.agent_sell != null && props.editBooking.agent_sell === true
            && props.editBooking.who_is_viewing === 'AGENT')
            && <a onClick={(e) => e.preventDefault()} className="reservation_details_actions_link"
              style={{
                color: '#004499',
                fontFamily: 'Roboto, sans-serif',
                fontWeight: 200,
                fontSize: '0.95rem',
              }}>
              <img src={solicitarFacturaIcon} alt="Descargar voucher" className="reservation_details_actions_icon" />
              <ShareDownload
                locator={props.locator}
                lang={props.lang}
                is_agent_voucher={true}
                className="font-normal"
              />
            </a>
            }
            {/*(props.bookingStatus === 'CONF' || props.isEditingBooking === true)
            && <a href="#" className="reservation_details_actions_link">
              <img src={solicitarFacturaIcon} alt="Solicitar factura" className="reservation_details_actions_icon" />
              {context.t('Request invoice')}
            </a>
            */}
          </div>

          <div className="reservation_details_actions_contact">
            <h3 className="reservation_details_actions_contact_title">{context.t('Contact Us')}</h3>
            {props.hotelPhone
              && renderCallCenterPhones()
            }
            <p className="reservation_details_actions_contact_info">
              <BookingDetailHotel locator={props.locator} email = {props.email}></BookingDetailHotel>
            </p>
          </div>

          {(props.bookingStatus !== 'CANC' || props.bookingStatus !== 'REV')
            && <p className="reservation_details_actions_footer">
                {context.t('Remember, you can make changes to this booking anytime.')}
              </p>
          }
        </div>
  );
};

ReservationDetailsActions.propTypes = {
  name: PropTypes.string.isRequired,
  bookingStatus: PropTypes.string.isRequired, // Para que desde booking detail mandemos el status y en booking detail actions sepamos si debemos dejar editar la booking o no dependiendo de su estatus
  hotelPhone: PropTypes.string.isRequired,
};

ReservationDetailsActions.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect((state) => ({
  multipleRoomSelection: state.booking.multipleRoomSelection,
  cart: state.cart,
  lang: state.i18nState.lang,
  locator: state.booking.book_locator,
  email: state.booking.book_email,
  hotel: state.booking.hotel,
  isEditingBooking: state.booking.isEditingBooking,
  clientIpCountryCode: state.booking.clientIpCountryCode,
  agentCode: state.bookingFormState.agentCode,
  agentSell: state.bookingFormState.agentSell,
  editBooking: state.booking.editBooking,
}))(ReservationDetailsActions);
